import { render, staticRenderFns } from "./course-catalog.vue?vue&type=template&id=5a94bc60&scoped=true"
import script from "./course-catalog.vue?vue&type=script&lang=js"
export * from "./course-catalog.vue?vue&type=script&lang=js"
import style0 from "./course-catalog.vue?vue&type=style&index=0&id=5a94bc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a94bc60",
  null
  
)

export default component.exports